import React from "react";
import "antd/dist/antd.less";
// import "antd/dist"
import "./styles/main.less";
import 'react-toastify/dist/ReactToastify.css';
import AppLayout from "./containers/layout";
import { AuthProvider } from "./contexts/auth/AuthContext";
import { ConfigProvider } from "antd";
import moment from "moment";
import ru_RU from "antd/lib/locale/ru_RU";
import "moment/locale/ru";
import "./styles/Dark.css"
import i18n from "./services/i18n";
import { ConfigProviderProps } from "antd/lib/config-provider";
import { ToastContainer } from 'react-toastify';
import {ThemeProvider} from "./contexts/ThemeContex";
// import moment from "moment";

const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: `'${i18n.t("requiredField")} - \${label}'`,
};

moment.locale("ru");

// notification.config({
//   placement: "bottomRight",
//   duration: 3,
// });

const antdConfig: ConfigProviderProps = {
  locale: ru_RU,
  form: { validateMessages },
};

function App() {
  return (
    <ConfigProvider {...antdConfig}>
      <AuthProvider>
        <ThemeProvider>
          <AppLayout />
          <ToastContainer position="bottom-right"/>
        </ThemeProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
